import apiHandler from './apiHandler';
import { toast } from "react-hot-toast";

const FetchUpdatedProductsAPI = async (request) => {
  try {

    const params = new URLSearchParams(request).toString();

    const response = await apiHandler({
      endpoint2: `/productsUpdated?${params}`,
      method: 'GET',
    });


    if (response?.response_code === 200) {
      return response;
    } else {
      toast.error(response.message || 'Failed to fetch Updated products');

      throw new Error(response.message || 'Failed to fetch Updated products');
    }
  } catch (error) {
    
    console.error("Error fetching Updated products", error);
    throw error;
  }
};

export default FetchUpdatedProductsAPI;
